import React from 'react';
import { BrainCircuit, Map, Ruler, Code2 } from 'lucide-react';

const features = [
  {
    icon: <BrainCircuit className="w-6 h-6 text-blue-600" />,
    title: 'Multi-Modal',
    text: '2 lidars, 1 stereo camera, 1 wide-view camera, 1 radar, 2 IMUs, other metadata.',
  },
  {
    icon: <Map className="w-6 h-6 text-green-600" />,
    title: 'Outdoor and Multi-Season',
    text: 'Canifers and deciduous trees. Rainfall, Dust clouds, Snow. Lots of snow.',
  },
  {
    icon: <Ruler className="w-6 h-6 text-red-600" />,
    title: 'Precise Time Sync and Spatial Calibration',
    text: 'Precision time protocol (PTP) and rigorous spatial calibration.',
  },
  {
    icon: <Code2 className="w-6 h-6 text-yellow-600" />,
    title: 'Open Source - MIT & CC',
    text: 'The dataset is licensed under CC BY-SA 4.0. Software is MIT licensed.',
  },
];

export default function KeyFeaturesSection() {
  return (
    <section className="py-24 bg-white dark:bg-neutral-900 text-black dark:text-white">
      <h2 className="text-4xl text-center font-extrabold tracking-tighttext-gray-800 dark:text-gray-100 mb-6">
        Key Features
      </h2>
      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-12 max-w-7xl mx-auto px-6">
        {features.map((feature, idx) => (
          <div
            key={idx}
            className="bg-white dark:bg-gray-800 p-8 rounded-lg shadow-md hover:shadow-lg transition duration-300 ease-in-out"
          >
            <div className="flex items-center justify-center mb-6 bg-gray-100 dark:bg-gray-700 p-4 rounded-full">
              {feature.icon}
            </div>
            <h3 className="text-lg font-semibold text-center text-gray-900 dark:text-gray-200">
              {feature.title}
            </h3>
            <p className="text-sm text-center text-gray-600 dark:text-gray-400 mt-2">
              {feature.text}
            </p>
          </div>
        ))}
      </div>
    </section>
  );
}
